import React from "react";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import { Assort } from "../../../models/Assort";
import getId from "../../../../utils/getId";
import { IoIosHelpCircleOutline } from "react-icons/io";
import AssortCard from "./AssortCard";

interface IProps {
  instructorAssort: Assort | undefined;
  loading: boolean;
}

const InstructorSummary: React.FC<IProps> = ({ instructorAssort, loading }) => {
  const getSwimmingTrackPrice = () => {
    if (instructorAssort !== undefined && getId(instructorAssort)) {
      return `Jego cena wynosi ${instructorAssort.listPrice} zł.`;
    } else {
      return "";
    }
  };

  if (loading) {
    return <EASkeletonLoader height="200px" />;
  }

  if (instructorAssort === undefined) {
    return <h5 className="text-centered">Nie znaleziono odpowiedniego asortymentu.</h5>;
  }

  return (
    <div className="gdansk-sale-instructor-summary">
      <h5 className="text-centered">Rezerwujesz tor do nauki pływania. {getSwimmingTrackPrice()}</h5>

      <AssortCard
        assort={instructorAssort}
        onAdd={() => {}}
        onDelete={() => {}}
        qnt={1}
        disabledAdding={true}
        disabledDelete
      />

      <div className="product-type-info">
        <span className="body-text-small">
          <IoIosHelpCircleOutline /> Objaśnienie
        </span>
        <br />
        <span className="caption">Jest to tylko rezerwacja toru. Bilety wstępu muszą być dokupione oddzielnie.</span>
      </div>
    </div>
  );
};

export default InstructorSummary;
